import * as React from 'react';
import Quote from "@system/config/quote";
import { useQuoteStore } from 'src/hooks/quote';
import System from 'src/helper/system';

export function OpenQuoteTableHeader() {
    const [{ openQuoteList, openQuoteCount }, { }, { }] = useQuoteStore();
    const isDisabled = (openQuoteList && openQuoteCount > 0) ? false : true;



    return (
        <>
            <div className="additional-word-wrap align-items-center border-0">
                <div className="ps5 d-flex align-items-center quote-tabs-links mb-0">
                    <p className="ps5 text-black-stone mb-0">My Open Quotes</p>
                    <a href={Quote.getQuoteListingRouteURL()} className='ms-1'>My Submitted Quotes</a>
                </div>
                <div className='text-end px-3 pt-4 quote-tabs-content'>
                    <button className={`bs5 btn btn-secondary w145 ${isDisabled ? 'disabled' : ''}`} data-toggle="modal" data-target="#clearquote-modal" disabled={isDisabled}
                        onClick={() => {
                            System.popup('ClearQuotePopup')
                        }}>CLEAR Quote</button>
                    <button className={`bs5 btn btn-primary w145 ms-2 ${isDisabled ? 'disabled' : ''}`} disabled={isDisabled} onClick={() => {
                         (window.location.href = Quote.getQuoteHeaderDetailRouteURL())
                    }}>CONTINUE</button>
                </div>
            </div>
        </>
    );

}
